<template>
  <v-app class="appbar">
    <v-app-bar dense flat :style="appbar()">
      <v-app-bar-nav-icon @click.stop="menu"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <a @click="top()" class="logo">
          <span class="green--text">Shif</span><span class="black--text">Cal</span>
        </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-chip
            color="indigo"
            text-color="white"
          >
            <v-avatar left>
              <v-icon>mdi-account-circle</v-icon>
            </v-avatar>
            {{auth.name}}
          </v-chip>


      <v-menu
          left
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="logout">
              <v-list-item-icon>
                <v-icon>exit_to_app</v-icon>
              </v-list-item-icon>
              <v-list-item-title>ログアウト</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

    </v-app-bar>
    <v-content>
      <v-container fluid class="con">
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
    >
      <v-list nav dense>
        <v-list-item-group>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            <v-icon>person</v-icon> {{auth.name}}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

          <v-list-item
            v-for="item in menus"
            :key="item.title"
            @click="link(item)"
          >
            <v-list-item-icon>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>

        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>


  </v-app>

</template>

<script>
import Auth from '@/components/Auth'
export default {
  mixins: [ Auth ],
  data () {
    return {
      drawer: true,
      right: null,
      appbarwidth: 'auto',
      menus: [],
      items: [
        { title: 'トップ画面', icon: 'event', link: '/top' },
        { title: 'シフト表（月間）', icon: 'event', link: '/month' },
        { title: 'シフト表（週間）', icon: 'view_week', link: '/week' },
        { title: 'シフト表変更履歴', icon: 'chrome_reader_mode', link: '/logs' },
        { title: '介護記録', icon: 'description', link: '/kiroku' },
        { title: '実績確認', icon: 'dashboard', link: '/jisseki' },
        { title: '印刷 介護記録', icon: 'print', link: '/kprint' },
        { title: '印刷 実績記録', icon: 'print', link: '/jprint' },
        { title: '設定', icon: 'vpn_key', link: '/pass' },
      ],
      admins: [
        { title: '利用者情報メンテ', icon: 'account_box', link: '/usermente' },
        { title: 'スタッフ情報メンテ', icon: 'account_box', link: '/staffmente' },
        { title: 'Line通知', icon: 'account_box', link: '/infoline' },
        // { title: 'ログイン情報メンテ', icon: 'dashboard', link: '/loginmente' }
      ]
    }
  },
  methods: {
    link (item) {
      this.$router.push(item.link)
    },
    top () {
      this.$router.push('/top')
    },
    appbar () {
      return 'min-width:' + this.appbarwidth + ';'
    },
    menu () {
      this.drawer = !this.drawer
      var auth = this.$store.getters.auth
      this.menus = this.items
      if (auth.role === 'admin') {
        this.menus = this.items.concat(this.admins)
      }
    }
  },
  computed: {
    auth: function () {
      return this.$store.getters.auth
    }
  },
  created () {
  }
}
</script>

<style lang="stylus">
  html {
    overflow-x scroll !important
  }
  body {
    font-family: "Helvetica Neue",Arial,
    'メイリオ', 'Meiryo','ＭＳ ゴシック',sans-serif;
  }
  
.dialog { overflow: initial; }

  .con {
    padding 2;
  }
  .container {
    padding 5
  }
  .appbar {
    min-width auto
  }
  .logo {
    color black
  }
</style>
